'use client';

import { motion } from 'motion/react';
import { useLocale } from './LocaleProvider';
import { dict, t } from '@/lib/i18n';
import { retailers, retailerCount } from '@/lib/retailers';

const groupOrder = ['international', 'resale', 'gcc'] as const;

export function Retailers() {
  const { locale } = useLocale();

  return (
    <section id="retailers" className="relative py-14 md:py-28 border-t border-white/5 bg-ink-800/40">
      <div className="mx-auto max-w-7xl px-5 sm:px-6">
        <div className="max-w-2xl mb-16">
          <div className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-gold-soft font-semibold mb-4">
            <span className="w-1 h-1 rounded-full bg-gold-soft" />
            {t(dict.retailers.eyebrow, locale)}
          </div>
          <h2 className="font-serif text-display-sm text-cream leading-[0.98]">
            {t(dict.retailers.heading, locale)}
          </h2>
          <p className="mt-3 text-fog-500 text-sm">
            {retailerCount}+ curated luxury domains · Only luxury, never fast fashion
          </p>
        </div>

        <div className="space-y-10">
          {groupOrder.map((group) => (
            <div key={group}>
              <div className="text-[11px] tracking-[0.25em] uppercase text-fog-500 font-semibold mb-4">
                {t(dict.retailers.groups[group], locale)}
              </div>
              <div className="flex flex-wrap gap-2">
                {retailers[group].map((r, i) => (
                  <motion.a
                    key={r.host}
                    href={`https://${r.host}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3, delay: Math.min(i * 0.02, 0.4) }}
                    className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-white/5 border border-white/10 text-sm text-fog-300 hover:border-gold/40 hover:text-cream hover:bg-white/10 transition"
                    dir="ltr"
                  >
                    {r.name}
                    <span className="text-[10px] text-fog-500 group-hover:text-gold-soft">↗</span>
                  </motion.a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
